import React, { Fragment, useEffect, useState } from 'react';


const BiFormSection = (props) => {

    const [show, setShow] = useState(props.show != null ? props.show : true);

    if (props.responsive == true) {
        return (
            <Fragment>
                <div className="row" onClick={() => setShow(!show)}>
                    <div className="col-sm-12">

                        <div className="biSection" style={{

                        }}>

                            {props.icon && <i className={props.icon} style={{ marginRight: "4px" }}></i>}
                            <span style={{ fontSize: "13px" }}>{props.label}</span>
                            <i className={show ? "fas fa-caret-down" : "fas fa-caret-up"} style={{ float: "right", marginTop: "4px" }}></i>
                        </div>
                    </div>
                </div>

                {show == true ? props.children : null}
            </Fragment>);
    }
    else {
        return (
            <Fragment>
                <tr onClick={() => setShow(!show)}>
                    <td colSpan={props.colSpan} >
                        <div className="biSection" style={{

                        }}>

                            {props.icon && <i className={props.icon} style={{ marginRight: "4px" }}></i>}
                            <span style={{ fontSize: "13px" }}>{props.label}</span>
                            <i className={show ? "fas fa-caret-down" : "fas fa-caret-up"} style={{ float: "right", marginTop: "4px" }}></i>
                        </div>
                    </td>
                </tr>

                {show == true ? props.children : null}
            </Fragment>);
    }
}

export default BiFormSection;

